(function () {
  'use strict';
  var PC = window.Pinkcode || { routes: { root_url: '/' }, moneyFormat: '£{{amount}}' };
  var root = (PC.routes.root_url || '/').replace(/\/$/, '');

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || PC.moneyFormat || '£{{amount}}';
    function fmt(n, dec, ts, ds) {
      dec = dec == null ? 2 : dec; ts = ts == null ? ',' : ts; ds = ds == null ? '.' : ds;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts) + (parts[1] ? ds + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m && m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function stripZeros(str) { return str.replace(/([.,])00(?!\d)/, ''); }

  /* ---------- drawers ---------- */
  function openDrawer(name) {
    var d = document.getElementById('drawer-' + name);
    if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer');
    var f = d.querySelector('button, a'); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.classList.remove('has-drawer');
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { closeDrawers(); return; }
    var c = e.target.closest('[data-cart-open]');
    if (c && PC.cartDrawer && !document.body.classList.contains('template-cart')) { e.preventDefault(); refreshCart().then(function () { openDrawer('cart'); }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- cart ---------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    document.querySelectorAll('[data-cart-count-text]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    var total = document.querySelector('[data-cart-total]'); if (total) total.textContent = formatMoney(cart.total_price);
    var list = document.querySelector('[data-cart-items]');
    var checkout = document.querySelector('[data-checkout-btn]');
    if (checkout) checkout.disabled = cart.item_count === 0;
    if (list) {
      if (!cart.items.length) { list.innerHTML = '<p class="c-empty">Your cart is empty</p>'; }
      else {
        list.innerHTML = cart.items.map(function (it) {
          var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
          var meta = [];
          if (!it.product_has_only_default_variant && it.variant_title) meta.push(esc(it.variant_title));
          if (it.selling_plan_allocation) meta.push(esc(it.selling_plan_allocation.selling_plan.name));
          var was = it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
          return '<div class="c-item">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') +
            '<div><a class="c-item__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
            '<p class="c-item__meta">' + meta.join(' · ') + '</p>' +
            '<div class="c-qty"><button type="button" data-cart-qty="' + it.key + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-cart-qty="' + it.key + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
            '<div class="c-item__price">' + formatMoney(it.final_line_price) + was + '</div></div>';
        }).join('');
      }
    }
    var need = parseInt(PC.freeShippingItems, 10) || 0;
    var box = document.querySelector('[data-ship-progress]');
    if (box) {
      if (need > 0 && cart.item_count > 0) {
        box.hidden = false;
        var left = need - cart.item_count;
        box.querySelector('[data-ship-text]').textContent = left > 0 ? 'Add ' + left + ' more item' + (left > 1 ? 's' : '') + ' for FREE UK delivery' : 'You’ve unlocked FREE delivery 💗';
        box.querySelector('[data-ship-bar]').style.width = Math.min(100, cart.item_count / need * 100) + '%';
      } else box.hidden = true;
    }
  }
  function refreshCart() {
    return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-qty]'); if (!b) return;
    b.disabled = true;
    fetch(root + '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.getAttribute('data-cart-qty'), quantity: Math.max(0, parseInt(b.getAttribute('data-q'), 10)) }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () { b.disabled = false; });
  });

  /* ---------- product: offers + subscription ---------- */
  function initOffers(scope) {
    var wrap = scope.querySelector('[data-offers]'); if (!wrap) return;
    var pj = wrap.querySelector('[data-product-json]');
    var bj = wrap.querySelector('[data-bundle-json]');
    var product = pj ? JSON.parse(pj.textContent) : null;
    var bundle = bj ? JSON.parse(bj.textContent) : null;
    var form = wrap.querySelector('[data-product-form]');
    var idInput = form.querySelector('[data-variant-input]');
    var planInput = form.querySelector('[data-plan-input]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var btn = form.querySelector('[data-add-btn]');
    var btnLabel = btn.querySelector('[data-add-label]');
    var defaultLabel = btnLabel.textContent;
    var subNote = wrap.querySelector('[data-sub-note]');
    var toggles = wrap.querySelectorAll('[data-mode]');
    var mode = toggles.length ? wrap.getAttribute('data-default-mode') : 'once';
    var errorEl = form.querySelector('[data-form-error]');

    function findVariant(source, id) {
      var p = source === 'bundle' ? bundle : product; if (!p) return null;
      for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(id)) return p.variants[i];
      return null;
    }
    function allocation(v) { return v && v.selling_plan_allocations && v.selling_plan_allocations.length ? v.selling_plan_allocations[0] : null; }

    function update() {
      toggles.forEach(function (t) { t.setAttribute('aria-checked', t.getAttribute('data-mode') === mode ? 'true' : 'false'); });
      if (subNote) subNote.hidden = mode !== 'subscribe';
      var selected = null;
      wrap.querySelectorAll('[data-offer]').forEach(function (input) {
        var card = input.closest('.offer');
        var v = findVariant(input.getAttribute('data-source'), input.value);
        card.classList.toggle('is-selected', input.checked);
        if (input.checked) selected = { input: input, v: v };
        if (!v) return;
        var a = mode === 'subscribe' ? allocation(v) : null;
        var qty = parseInt(input.getAttribute('data-qty') || '1', 10);
        var paid = parseInt(input.getAttribute('data-paid') || '1', 10);
        var unit = a ? a.price : v.price;
        var unitCompare = a ? (a.compare_at_price || v.price) : (v.compare_at_price || 0);
        if (v.compare_at_price && v.compare_at_price > unitCompare) unitCompare = v.compare_at_price;
        if (qty > 1 && unitCompare < v.price) unitCompare = v.price;
        var price = unit * paid;
        var compare = unitCompare * qty;
        card.querySelector('[data-price]').textContent = formatMoney(price);
        var cmp = card.querySelector('[data-compare]');
        cmp.textContent = compare && compare > price ? formatMoney(compare) : '';
        var save = card.querySelector('[data-save]');
        if (compare && compare > price) { save.hidden = false; save.textContent = 'SAVE ' + stripZeros(formatMoney(compare - price)); } else save.hidden = true;
      });
      if (!selected) return;
      idInput.value = selected.input.value;
      if (qtyInput) qtyInput.value = selected.input.getAttribute('data-qty') || '1';
      var al = mode === 'subscribe' ? allocation(selected.v) : null;
      if (planInput) { if (al) { planInput.value = al.selling_plan_id; planInput.disabled = false; } else { planInput.value = ''; planInput.disabled = true; } }
      var avail = selected.v ? selected.v.available : true;
      btn.disabled = !avail;
      btnLabel.textContent = avail ? defaultLabel : 'Sold out';
      if (selected.input.getAttribute('data-source') === 'main' && selected.v) {
        var url = new URL(window.location.href); url.searchParams.set('variant', selected.v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    var sticky = scope.querySelector('[data-sticky-atc]');
    if (sticky && 'IntersectionObserver' in window) {
      var sBtn = sticky.querySelector('[data-sticky-btn]');
      sBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else btn.click(); });
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(btn);
    }
    function syncSticky() {
      if (!sticky) return;
      var sel = wrap.querySelector('[data-offer]:checked');
      var price = sel && sel.closest('.offer').querySelector('[data-price]');
      var title = sel && sel.closest('.offer').querySelector('.offer__title');
      var sp = sticky.querySelector('[data-sticky-price]');
      if (price && sp) sp.textContent = (title ? title.textContent + ' · ' : '') + price.textContent;
    }
    wrap.addEventListener('change', function (e) { if (e.target.matches('[data-offer]')) { update(); syncSticky(); } });
    toggles.forEach(function (t) { t.addEventListener('click', function () { mode = t.getAttribute('data-mode'); update(); syncSticky(); }); });
    update(); syncSticky();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      btn.disabled = true; btn.classList.add('is-loading');
      var item = { id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput ? qtyInput.value : '1', 10) || 1 };
      if (planInput && !planInput.disabled && planInput.value) item.selling_plan = parseInt(planInput.value, 10);
      fetch(root + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          if (!PC.cartDrawer) { window.location.href = PC.routes.cart_url; return; }
          return refreshCart().then(function () { openDrawer('cart'); });
        })
        .catch(function (err) { if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; errorEl.hidden = false; } })
        .finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery(scope) {
    var g = scope.querySelector('[data-gallery]'); if (!g) return;
    var track = g.querySelector('[data-gallery-track]');
    var dots = g.querySelectorAll('[data-gallery-dots] button');
    var thumbs = g.querySelectorAll('[data-gallery-thumbs] button');
    function go(i) { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
    function mark(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 60); });
  }

  /* ---------- countdown (real end date only) ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var raw = el.getAttribute('data-countdown').trim().replace(' ', 'T');
      var end = new Date(raw);
      if (isNaN(end.getTime())) return;
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.floor((end - new Date()) / 1000);
        if (diff <= 0) { el.hidden = true; clearInterval(iv); return; }
        el.hidden = false;
        h.textContent = pad(Math.floor(diff / 3600)); m.textContent = pad(Math.floor(diff % 3600 / 60)); s.textContent = pad(diff % 60);
      }
      var iv = setInterval(tick, 1000); tick();
    });
  }

  /* ---------- carousels ---------- */
  function initCarousels(scope) {
    scope.querySelectorAll('[data-carousel]').forEach(function (c) {
      var sec = c.closest('section') || scope;
      var step = function () { var it = c.firstElementChild; return it ? it.getBoundingClientRect().width + 18 : 300; };
      var p = sec.querySelector('[data-carousel-prev]'), n = sec.querySelector('[data-carousel-next]');
      if (p) p.addEventListener('click', function () { c.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { c.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
    scope.querySelectorAll('[data-play]').forEach(function (b) {
      b.addEventListener('click', function () {
        var fig = b.closest('figure'), v = fig.querySelector('video'); if (!v) return;
        if (v.paused) { v.muted = false; v.play(); fig.classList.add('is-playing'); } else { v.pause(); fig.classList.remove('is-playing'); }
      });
    });
  }

  /* ---------- before / after ---------- */
  function initBeforeAfter(scope) {
    scope.querySelectorAll('[data-ba]').forEach(function (ba) {
      var r = ba.querySelector('[data-ba-range]');
      r.addEventListener('input', function () { ba.style.setProperty('--pos', r.value + '%'); });
    });
  }

  function init(scope) { initOffers(scope); initGallery(scope); }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-section]').forEach(init);
    initCarousels(document); initBeforeAfter(document); initCountdowns();
    if (document.querySelector('[data-cart-items]')) refreshCart().catch(function () {});
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initCarousels(e.target); initBeforeAfter(e.target); initCountdowns(); });
})();
